import React, { useState, useEffect, ChangeEvent } from 'react'
import { SelectChangeEvent } from '@mui/material/Select'
import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import UseAlert from '../../components/common/useAlerte'
import { addProjet } from '../../redux/projets/projetActions'
import { getMissions } from '../../redux/missions/missionActions'
import SelectPriority from '../../components/common/SelectPriority'
import DateSelector from '../../components/common/Date'
import SelectTypeProjet from '../../components/common/SelectTypeProjet'
import SelectPipeline from '../pipeline/SelectPipeline'
import { useSelector } from 'react-redux'
import { useAppDispatch, RootState, AppDispatch } from '../../redux/store'
import SelectStatut from '../../components/common/SelectStatut'
import { createSanitizedObjectHandler } from '../../utils/inputHandlers'
import NumberInput from '../../components/common/NumberInput'
import { MissionSummaryCard } from '../../components/quickCreate/ParentSummaryCard'
import { useMissionBudget } from '../../components/quickCreate/parentInfo'
import {
  FormAside,
  FormField,
  FormFoot,
  FormGrid,
  FormLayout,
  FormPageHead,
  FormSection,
  FormShell,
} from '../../components/common/form'
import './addprojet-menu-fix.css'

const AddNewProjectMission = () => {
  const { idmission } = useParams<{ idmission: string }>()

  console.log(idmission)
  const [currentPageSize, setCurrentPageSize] = useState<number>(5)
  const [priority, setPriority] = useState<number>(3)
  const [status, setStatus] = useState<string>('A faire')
  const [TypeProjet, setTypeProjet] = useState<string>('Other')
  const [MissionId, setMissionId] = useState<string>(idmission || '')
  const [PipelineId, setPipelineId] = useState<string>('')

  const status1 = useSelector(
    (state: RootState) => state.projet.addedProjet?.status
  )
  const message = useSelector(
    (state: RootState) => state.projet.addedProjet?.message
  )
  console.log(message)

  const dispatch: AppDispatch = useAppDispatch()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const missionBudget = useMissionBudget(MissionId || undefined)

  const [alert, setAlert] = useState({
    open: false,
    message: '',
    status: 0,
  })

  const handleDateChange = (dates: [Date, Date] | null) => {
    if (dates) {
      const [startDate, endDate] = dates
      setProjet((prevProjet) => ({
        ...prevProjet,
        DateDebut: startDate,
        DateFin: endDate,
      }))
    }
  }

  type SingleState = string | number | string[]

  const createHandler =
    <T extends SingleState>(
      setState: React.Dispatch<React.SetStateAction<T>>,
      property: string
    ) =>
    (event: ChangeEvent<{ value: T }>) => {
      const { value } = event.target
      setState(value)
      setProjet((prevProjet) => ({
        ...prevProjet,
        [property]: value,
      }))
    }

  const handlePipelineChange = createHandler(setPipelineId, 'PipelineId') as (
    event: ChangeEvent<{ value: string }> | SelectChangeEvent<string>
  ) => void

  const handleMissionChange = (newMission: string) => {
    setMissionId(newMission)
    setPipelineId('')
    setProjet((prevProjet) => ({
      ...prevProjet,
      MissionId: newMission,
      PipelineId: '',
    }))
  }

  const handlePriorityChange = createHandler(setPriority, 'Priority') as (
    event: React.ChangeEvent<{ value: number }> | SelectChangeEvent<number>
  ) => void

  const handleTypeProjet = createHandler(setTypeProjet, 'TypeProjet') as (
    event: ChangeEvent<{ value: string }> | SelectChangeEvent<string>
  ) => void

  const handleStatusChange = createHandler(setStatus, 'Status') as (
    event: ChangeEvent<{ value: string }> | SelectChangeEvent<string>
  ) => void

  useEffect(() => {
    dispatch(getMissions({ page: 1, pageSize: currentPageSize }))
  }, [currentPageSize, dispatch])

  useEffect(() => {
    const className = 'addprojet-menus-zoom-fix'
    document.body.classList.add(className)
    return () => {
      document.body.classList.remove(className)
    }
  }, [])

  const [projet, setProjet] = useState({
    ProjetName: '',
    Description: '',
    DateDebut: new Date(),
    DateFin: new Date(),
    Status: 'A faire',
    Priority: 3,
    Budget: 0,
    TypeProjet: 'Autres',
    Source: '',
    MissionId: idmission,
    PipelineId: '',
  })
  const handleInputChange = createSanitizedObjectHandler(setProjet, {
    ProjetName: 'text',
    Description: 'text',
    Source: 'text',
    Budget: 'numbers',
  })

  const handleBudgetChange = (value: number | null) => {
    setProjet((prevProjet) => ({
      ...prevProjet,
      Budget: value ?? 0,
    }))
  }

  const handleCloseAlert = () => {
    setAlert({
      ...alert,
      open: false,
    })
    if (status1 === 200) {
      navigate(`/mission-details/${MissionId}`)
    }
  }

  const submitLabel = t('buttons.add')

  const handleAddProjet = async () => {
    if (
      !projet.ProjetName ||
      !projet.Description ||
      !projet.DateDebut ||
      !projet.DateFin ||
      !projet.Status ||
      !projet.Priority ||
      !projet.TypeProjet
    ) {
      setAlert({
        open: true,
        message: t('errors.projectCreation.validation.requiredFields'),
        status: 0,
      })
      return
    }

    if (projet.Budget < 0) {
      setAlert({
        open: true,
        message: t('errors.projectCreation.validation.invalidBudget'),
        status: 0,
      })
      return
    }

    if (projet.DateFin < projet.DateDebut) {
      setAlert({
        open: true,
        message: t('errors.projectCreation.validation.endDateBeforeStart'),
        status: 0,
      })
      return
    }

    try {
      const formattedProjet = {
        ...projet,
        Priority: Number(projet.Priority),
        // Hidden on this form. The API still requires Source.
        Source: projet.Source || 'N/A',
      }

      await dispatch(addProjet(formattedProjet)).unwrap()

      setAlert({
        open: true,
        message: message || t('errors.projectCreation.message'),
        status: status1 || 200,
      })

      setProjet({
        ProjetName: '',
        Description: '',
        DateDebut: new Date(),
        DateFin: new Date(),
        Status: 'A faire',
        Priority: 3,
        Budget: 0,
        TypeProjet: 'Autres',
        Source: '',
        MissionId: idmission,
        PipelineId: '',
      })
    } catch (error: any) {
      setAlert({
        open: true,
        message: error || t('errors.projectCreation.unknown'),
        status: 0,
      })
    }
  }

  return (
    <div className="page-content addprojet-page">
      <FormPageHead
        eyebrow={t('entityForms.project.createEyebrow', {
          defaultValue: 'Management · Projects',
        })}
        title={t('buttons.addProject', { defaultValue: 'New project' })}
        subtitle={t('entityForms.project.createSubtitle', {
          defaultValue:
            'Set up project identity, planning, budget and pipeline linkage.',
        })}
        backLabel={t('entityForms.project.backToList', {
          defaultValue: 'Back to projects',
        })}
        onBack={() =>
          MissionId
            ? navigate(`/mission-details/${MissionId}`)
            : navigate('/projets')
        }
      />

      <UseAlert
        open={alert.open}
        message={message || ''}
        status={status1 || 0}
        onClose={handleCloseAlert}
      />

      <FormLayout
        main={
          <FormShell>
            <FormSection
              title={t('entityForms.project.identityTitle', {
                defaultValue: 'Identification',
              })}
            >
              <FormGrid cols={2}>
                <FormField label={t('Project Name')} required span>
                  <input
                    className="incyia-form-inp"
                    name="ProjetName"
                    value={projet.ProjetName}
                    onChange={handleInputChange as any}
                    required
                  />
                </FormField>
                <FormField label={t('Pipeline')} span>
                  <SelectPipeline
                    value={PipelineId}
                    onChange={handlePipelineChange}
                    MissionId={MissionId}
                    disabled={false}
                    disablePortalMenu
                  />
                </FormField>
                <FormField label={t('Description')} required span>
                  <textarea
                    className="incyia-form-inp"
                    name="Description"
                    value={projet.Description}
                    onChange={handleInputChange as any}
                    rows={4}
                    required
                  />
                </FormField>
              </FormGrid>
            </FormSection>

            <FormSection
              title={t('entityForms.project.planningTitle', {
                defaultValue: 'Planning and cost',
              })}
            >
              <FormGrid cols={2}>
                <FormField label={t('Project Type')}>
                  <SelectTypeProjet
                    value={TypeProjet}
                    onChange={handleTypeProjet}
                    disablePortalMenu
                  />
                </FormField>
                <FormField
                  label={t('entityForms.project.dates', {
                    defaultValue: 'Start & end dates',
                  })}
                >
                  <DateSelector
                    placeholder={t('entityForms.datePlaceholder')}
                    onDateChange={handleDateChange}
                  />
                </FormField>
                <FormField label={t('Budget')} required>
                  <NumberInput
                    currency
                    min={0}
                    name="Budget"
                    value={projet.Budget}
                    onChange={handleBudgetChange}
                    required
                  />
                </FormField>
                <FormField label={t('Status')}>
                  <SelectStatut
                    value={status}
                    onChange={handleStatusChange}
                    disablePortalMenu
                  />
                </FormField>
                <FormField label={t('Priority')}>
                  <SelectPriority
                    value={priority}
                    onChange={handlePriorityChange}
                    disablePortalMenu
                  />
                </FormField>
              </FormGrid>
            </FormSection>

            <FormFoot
              note={t('actionCreate.aside.requiredMark', {
                defaultValue: '* Required',
              })}
              cancelLabel={t('buttons.cancel', { defaultValue: 'Cancel' })}
              submitLabel={submitLabel}
              onCancel={() =>
                MissionId
                  ? navigate(`/mission-details/${MissionId}`)
                  : navigate('/projets')
              }
              onSubmit={handleAddProjet}
            />
          </FormShell>
        }
        aside={
          <FormAside
            title={t('actionCreate.aside.inThisForm', {
              defaultValue: 'In this form',
            })}
            tipTitle={t('actionCreate.aside.goodToKnow', {
              defaultValue: 'Good to know',
            })}
            tip={t('entityForms.project.tip', {
              defaultValue:
                'Pipeline and dates drive the Gantt view on the project detail page.',
            })}
            context={
              MissionId ? (
                <>
                  <MissionSummaryCard
                    plain
                    info={missionBudget.data}
                    status={missionBudget.status}
                  />
                  <p className="incyia-aside-note incyia-aside-divider">
                    {t('parentLimits.stayInside')}
                  </p>
                </>
              ) : undefined
            }
            steps={[
              {
                title: t('entityForms.project.identityTitle', {
                  defaultValue: 'Identification',
                }),
                fieldCount: 3,
              },
              {
                title: t('entityForms.project.planningTitle', {
                  defaultValue: 'Planning and cost',
                }),
                fieldCount: 5,
              },
            ]}
            requiredCount={3}
            submitLabel={submitLabel}
            fieldsLabel={(n) =>
              t(
                n === 1
                  ? 'actionCreate.aside.fields_one'
                  : 'actionCreate.aside.fields_other',
                { count: n, defaultValue: `${n} fields` }
              )
            }
            requiredNote={(count, submit) =>
              t('actionCreate.aside.requiredNote', {
                count,
                submit,
                defaultValue: `${count} required before you can ${submit}.`,
              })
            }
          />
        }
      />
    </div>
  )
}

export default AddNewProjectMission
